/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class PagosParafiscalesService {

	private API_URL;
	constructor(private http: HttpClient, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	getDataTable(entry: any): Observable<ResponseServiceModel> {
		// tslint:disable-next-line:max-line-length
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Reporte/PaginadoReportePagosParafiscales?PageNumber=${entry.numeroPagina}&PageSize=12`, entry).pipe(
			retry(2)
		);
	}

	getCategoria(): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/Categoria/GetCategoriaParafiscales`).pipe(
			retry(2)
		);
	}

	getSubCategoria(): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/SubCategoria/PorCategoriaParafiscal`).pipe(
			retry(2)
		);
	}

	getSubCategoriaxCategoria(id: any): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/SubCategoria/PorCategoriaParafiscal?id=${id}`).pipe(
			retry(2)
		);
	}

	generarExportarPagosParafiscales(entry: any) {
		// tslint:disable-next-line:max-line-length
		return this.http.post<any>(`${this.API_URL}/Reporte/GenerarExportarPagosParafiscales`, entry, { observe: 'response' }).pipe(
			retry(2)
		);
	}

}